import { TCompanyState } from '@/redux/reducers/company';
import { TGetLicenseOverviewSuccess } from '@/redux/actions/company';

export const getLicenseOverviewUpdateState = (
  state: TCompanyState,
  action: TGetLicenseOverviewSuccess,
): TCompanyState => {
  const updatedState = {
    ...state,
    licenseOverviewResponse: action.payload.response,
  };
  return updatedState;
};
